import { feedbacksConstants } from '@constants/feedbacks';

const initialState = {
    loading: true,
    newFeedbacksExist: false,
    feedbacks: [],
    pageToken: null,
};

export function feedbacks(state = initialState, action) {
    switch (action.type) {
        case feedbacksConstants.FEEDBACKS_REQUEST:
            return { ...state, loading: true, pageToken: null };
        case feedbacksConstants.FEEDBACKS_SUCCESS:
            return {
                ...state,
                feedbacks: action.payload.items,
                pageToken: action.payload.nextPageToken,
                loading: false,
            };
        case feedbacksConstants.FEEDBACKS_LOAD_MORE_SUCCESS:
            return {
                ...state,
                feedbacks: [...state.feedbacks, ...action.payload.items],
                pageToken: action.payload.nextPageToken,
            };
        case feedbacksConstants.FEEDBACKS_REFETCH_SUCCESS:
            return {
                ...state,
                feedbacks: action.payload.items,
                pageToken: action.payload.nextPageToken,
            };
        case feedbacksConstants.FEEDBACKS_UPDATE:
            return { ...state, feedbacks: action.payload };
        case feedbacksConstants.NEW_FEEDBACK_EXIST_SUCCESS:
            return { ...state, newFeedbacksExist: action.payload };
        case feedbacksConstants.NEW_FEEDBACK_EXIST_RESET:
            return { ...state, newFeedbacksExist: false };
        case feedbacksConstants.RESET_LOADING:
            return { ...state, loading: false };
        case feedbacksConstants.FEEDBACKS_ERROR:
        default:
            return state;
    }
}
